module.exports = window.jQuery;